import React, { memo } from 'react';

import EntityFormModal from '@sharedCR/common/EntityFormModal';

import { usePrepareDisclosuresWizard } from '../../hooks';
import { WIZARD_TITLE } from '../../PrepareDisclosuresWizard.constants';
import PrepareDisclosuresWizardBody from '../PrepareDisclosuresWizardBody';
import PrepareDisclosuresWizardFooter from '../PrepareDisclosuresWizardFooter';

const customControls = <PrepareDisclosuresWizardFooter />;

const PrepareDisclosuresWizardDrawer = () => {
  const { isOpen, requestClose } = usePrepareDisclosuresWizard();

  return (
    <EntityFormModal
      isData
      isHiddenNavigationTabs
      Content={PrepareDisclosuresWizardBody}
      customControls={customControls}
      isOpen={isOpen}
      title={WIZARD_TITLE}
      onClose={requestClose}
    />
  );
};

export default memo(PrepareDisclosuresWizardDrawer);
